import React from 'react'

interface ImageLinkProps {
  /**
   * @type {string}
   */
  src: string
  /**
   * @type {string}
   */
  alt?: string
  /**
   * @type {number}
   */
  width?: number
  /**
   * @type {number}
   */
  height?: number
  // /**
  //  * @type {object}
  //  */
  style?: React.CSSProperties
}

const ImageLink: React.FC<ImageLinkProps> = ({
  src = '#',
  alt,
  width,
  height,
  style,
}) => {
  const pathPrefix = 'https://www.paypalobjects.com/ppdevdocs/bundle'
  if (src.startsWith('/img')) {
    return (
      <img
        src={`${pathPrefix}${src}`}
        alt={alt}
        width={width}
        height={height}
        style={style}
      />
    )
  }
  return <img src={src} alt={alt} width={width} height={height} style={style} />
}

export default ImageLink
